import Http from './zyb-axios'
import api from './api'
import _ from 'lodash'
export const apis = _.mapValues(
  api,
  _.bind(_.mapValues, null, _, (v: any) => v + ``)
)
export default Http(apis)
